module.exports = __webpack_public_path__ + "files/acdd2f2e4050367ca46cbcad5c03fe44.png";